"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("./styles");
/**
 * CheckboxInfo component
 * @return {Object}
 */
var CheckboxInfo = function CheckboxInfo(_ref) {
  var label = _ref.label,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    value = _ref.value,
    className = _ref.className,
    dataTestId = _ref['data-testid'];
  var customClass = "".concat(className, ", 'form-control'");
  var bool = false;
  var handleChange = function handleChange(e) {
    if (e.target.value === 'true') bool = true;else if (e.target.value === 'false') bool = false;
    onChange(bool);
  };
  var checkbox = /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    className: "checkbox",
    checked: !!value,
    onChange: handleChange,
    value: value ? 'true' : 'false'
  });
  var startAdornment = /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
    position: "start",
    className: "adorn"
  }, /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
    className: "label",
    control: checkbox,
    label: ""
  }));
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: customClass,
    variant: "filled"
  }, /*#__PURE__*/_react["default"].createElement(_core.FilledInput, {
    className: className,
    inputProps: {
      readOnly: true
    },
    startAdornment: startAdornment,
    value: label,
    "data-testid": dataTestId
  }));
};
exports.CheckboxInfo = CheckboxInfo;